<template>
  <div class="foot">
    <div class="foot_center flex_col">
      <div class="foot_center_top flex_row">
        <div class="flex_col flex_hover">
          <div class="txt">友情链接</div>
          <p
            v-for="(item, index) in bloList"
            :key="index"
            @click="openUrl(item.url)"
          >
            {{ item.title }}
          </p>
        </div>
        <div class="flex_col flex_hover">
          <div class="txt">技术服务</div>
          <p
            v-for="(item, index) in serviceTypesList"
            :key="index"
            @click="ToSearve(item, index)"
          >
            {{ item.serviceType }}
          </p>
        </div>
        <div class="flex_col">
          <div class="txt">联系我们</div>
          <div>
            <p>{{ contactInformationDto.phone }}</p>
          </div>
          <div>
            <p>{{ contactInformationDto.coding }}</p>
          </div>
          <div>
            <p>{{ contactInformationDto.address }}</p>
          </div>
        </div>
        <div class="flex_row">
          <div class="flex_col" v-for="(item, index) in adList" :key="index">
            <div class="txt">
              <img :src="item.imageUrl" alt="" />
            </div>
            <p class="flex_col_text">{{ item.title }}</p>
          </div>
        </div>
      </div>
      <div class="foot_center_bottom">
        <p>{{ websiteInfo.copyright }}</p>
        <div style="margin-top: 10px">
          {{ websiteInfo.record }}
          <p @click="openUrl('https://beian.miit.gov.cn')">
            &nbsp;{{ websiteInfo.domain }}
          </p>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { getUnderInfoListApi } from "@/api/index";
export default {
  name: "Foot",
  data() {
    return {
      phone: "",
      email: "",
      address: "",
      urlList: [],
      downloadList: [],
      bloList: [],
      serviceTypesList: [],
      contactInformationDto: {},
      adList: [],
      websiteInfo: {},
    };
  },
  mounted() {
    this.getUnderInfoList();
  },
  methods: {
    //获取底部信息
    getUnderInfoList() {
      getUnderInfoListApi().then((res) => {
        console.log(res);
        this.bloList = res.data.bloList;
        this.serviceTypesList = res.data.serviceTypesList;
        this.contactInformationDto = res.data.contactInformationDto;
        this.adList = res.data.adList;
        this.websiteInfo = res.data.websiteInfo;
      });
    },
    ToSearve(item, index) {
      this.$emit("goRouter", index + 1);
      //传给sever页面index参数
      this.$router.push({
        path: "/service",
        query: {
          index: index + 1,
        },
      });
      console.log(index + 1);
    },
    //下载连接
    down(jump) {
      window.open(jump);
    },
    //打开链接
    openUrl(jump) {
      window.open(jump);
    },
  },
};
</script>
<style scoped>
.foot {
  background: #111317;
  /*width: 100%;*/
  /*height: 308px;*/
  min-width: 1200px;
}
.foot_center {
  width: 1200px;
  height: 100%;
  margin: 0 auto;
  /*background: yellowgreen;*/
  justify-content: space-between;
  align-items: center;
  padding-top: 30px;
  padding-bottom: 20px;
  box-sizing: border-box;
  color: #525c60;
  font-size: 14px;
}
.foot_center_top {
  width: 100%;
  justify-content: space-around;
}
.foot_center_top .txt {
  color: white;
  margin-right: 50px;
  margin-bottom: 20px;
}
.foot_center_top .txt img {
  width: 119px;
  height: 119px;
}
.foot_center_top p {
  margin-bottom: 14px;
}
.foot_center_bottom div {
  display: flex;
  align-items: center;
}
.foot_center_bottom p {
  text-align: center;
  font-size: 12px;
}

.flex_col_text {
  color: #ffffff;
  text-align: center;
  margin-right: 50px;
}
.flex_hover p:hover {
  color: white;
  cursor: pointer;
}
</style>



// WEBPACK FOOTER //
// src/views/components/Foot.vue